"use strict";

exports.__esModule = true;
exports.CalendarEventFieldSet = CalendarEventFieldSet;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _CalendarEventTypeField = require("./CalendarEventTypeField");
var _CalendarEventNameField = require("./CalendarEventNameField");
var _CalendarEventClassificationStateField = require("./CalendarEventClassificationStateField");
var _CalendarEventFromField = require("./CalendarEventFromField");
var _CalendarEventToField = require("./CalendarEventToField");
var _CalendarEventOccursWeeklyField = require("./CalendarEventOccursWeeklyField");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Condition = function Condition(_ref) {
  var when = _ref.when,
    is = _ref.is,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: when,
    subscription: {
      value: true
    }
  }, function (_ref2) {
    var value = _ref2.input.value;
    return value === is || typeof is === "function" && is(value) ? children : null;
  });
};
var validateEventFields = function validateEventFields(input) {
  var errors = {};
  if (!input.occursWeekly || input.occursWeekly.length === 0) {
    errors.occursWeekly = "Must select at least one day.";
  }
  return errors;
};
function CalendarEventFieldSet(_ref3) {
  var prefix = _ref3.prefix,
    onRemove = _ref3.onRemove;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: prefix,
    validate: validateEventFields
  }, function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "CalendarEventFieldSet",
      style: {
        flex: 1,
        overflowY: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_CalendarEventTypeField.CalendarEventTypeField, {
      prefix: prefix
    }), /*#__PURE__*/_react["default"].createElement(Condition, {
      when: prefix + ".type",
      is: "Shift"
    }, /*#__PURE__*/_react["default"].createElement(_CalendarEventNameField.CalendarEventNameField, {
      prefix: prefix + ".payload"
    })), /*#__PURE__*/_react["default"].createElement(Condition, {
      when: prefix + ".type",
      is: "Classification"
    }, /*#__PURE__*/_react["default"].createElement(_CalendarEventClassificationStateField.CalendarEventClassificationStateField, {
      key: "payload.state",
      prefix: prefix + ".payload"
    })), /*#__PURE__*/_react["default"].createElement(_CalendarEventFromField.CalendarEventFromField, {
      prefix: prefix
    }), /*#__PURE__*/_react["default"].createElement(_CalendarEventToField.CalendarEventToField, {
      prefix: prefix
    }), /*#__PURE__*/_react["default"].createElement(_CalendarEventOccursWeeklyField.CalendarEventOccursWeeklyField, {
      prefix: prefix
    }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: "delete",
      onClick: onRemove
    }, translate("CalenderEventFieldSet.deleteButton", "Delete this event")));
  });
}